var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { styled } from '@material-ui/core/styles';
import { flexibleLayoutContainer } from '../styleUtility/flexibleLayout';
import React from 'react';
var SigningInIndicatorScreen = function (_a) {
    var _b = _a.visible, visible = _b === void 0 ? false : _b, className = _a.className;
    return (React.createElement(Root, { className: className, style: {
            opacity: visible ? 1 : 0,
            visibility: visible ? 'visible' : 'hidden',
            transition: "opacity 300ms ease-in-out 0ms,\n               visibility 0ms linear " + (visible ? 0 : 300) + "ms",
        } },
        React.createElement(Indicator, { style: {
                opacity: visible ? 1 : 0,
            } })));
};
var Root = styled('div')(__assign(__assign({}, flexibleLayoutContainer({
    alignItems: 'center',
    justifyContent: 'center',
})), { background: '#fff' }));
var Indicator = styled('div')({
    width: 64,
    height: 64,
    backgroundImage: 'url("/assets/spinner.gif")',
    backgroundSize: 'cover',
});
export default SigningInIndicatorScreen;
